import { render, staticRenderFns } from "./SportelloContrattiAttiviView.vue?vue&type=template&id=6090dcaa&"
import script from "./SportelloContrattiAttiviView.vue?vue&type=script&lang=ts&"
export * from "./SportelloContrattiAttiviView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports